import { z } from 'zod';

/**
 * The backend's fixed placeholder list (`SHORTCUT_PLACEHOLDERS` in the conversations Zod
 * contract, documented on the shortcut body). Unknown names render empty, so the editor offers
 * only these.
 */
export const SHORTCUT_PLACEHOLDERS = [
  'customer.firstName',
  'customer.lastName',
  'customer.email',
  'order.number',
  'order.trackingUrl',
  'store.name',
  'agent.firstName',
] as const;

export const MAX_SHORTCUT_ATTACHMENTS = 5;
export const MAX_SHORTCUT_PRODUCTS = 10;
export const MAX_SUGGESTED_REPLIES = 4;

export const shortcutSchema = z.object({
  key: z
    .string()
    .trim()
    .regex(/^[a-z0-9-]{1,40}$/, { error: 'chatSettings:validation.shortcutKey' }),
  title: z
    .string()
    .trim()
    .min(1, { error: 'chatSettings:validation.titleRequired' })
    .max(120, { error: 'chatSettings:validation.max120' }),
  body: z
    .string()
    .trim()
    .min(1, { error: 'chatSettings:validation.bodyRequired' })
    .max(4000, { error: 'chatSettings:validation.max4000' }),
  scope: z.enum(['personal', 'store', 'organization']),
  attachments: z.array(z.string()).max(MAX_SHORTCUT_ATTACHMENTS),
  productIds: z.array(z.string()).max(MAX_SHORTCUT_PRODUCTS),
  suggestedReplies: z.array(z.string().trim().min(1).max(80)).max(MAX_SUGGESTED_REPLIES),
});

export type ShortcutForm = z.infer<typeof shortcutSchema>;
export type ShortcutScope = ShortcutForm['scope'];
